import * as React from "react";
import ReactTable from "react-table";
import { FiltroConsultaHistorico, RespuestaTSAT } from "../modelo/ReporteHistoricoModelo";
import { ModalDetalleJson } from "../../config_general/componentes/ModalDetalleJson";

export default class TablaRespuestasTSAT extends React.Component<TablaRespuestasTSATProps, any> {

    columns = [{
        id: "consecutivoMensaje",
        Header: "Consecutivo",
        accessor: "consecutivoMensaje",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "respuestaSAT",
        Header: "Respuesta SAT",
        accessor: "respuestaSAT",
        Cell: props => (this.renderDetalleJson(props, props.original.respuestaSAT)),
        width: 100
    }, {
        id: "fechaEnvio",
        Header: "Fecha Envio",
        accessor: "fechaEnvio",
        Cell: props => (this.renderTexto(props)),
        width: 150
    }, {
        id: "fechaRespuesta",
        Header: "Fecha Respuesta",
        accessor: "fechaRespuesta",
        Cell: props => (this.renderTexto(props)),
        width: 150
    }, {
        id: "intento",
        Header: "Numero Envio",
        accessor: "intento",
        Cell: props => (this.renderTexto(props)),
        width: 90
    }, {
        id: "mensajeEnvio",
        Header: "Mensaje Envio",
        accessor: "mensajeEnvio",
        Cell: props => (this.renderDetalleJson(props, props.original.mensajeEnvio)),
        width: 100
    }, {
        id: "error",
        Header: "Error",
        accessor: "error",
        Cell: props => (this.renderTexto(props)),
        width: 60
    }, {
        id: "motivoRechazo",
        Header: "Motivo Rechazo",
        accessor: "motivoRechazo",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "reproceso",
        Header: "Numero Reproceso",
        accessor: "reproceso",
        Cell: props => (this.renderTexto(props)),
        width: 110
    }, {
        id: "dniReprocesa",
        Header: "Dni Reprocesa",
        accessor: "dniReprocesa",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }];

    render() {
        const { respuestasTSAT, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (respuestasTSAT.length < tamanoPagina) {
            numRegistros = respuestasTSAT.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{respuestasTSAT.length}</span> Parámetros encontrados
                    </h2>
                </div>
                <ReactTable data={respuestasTSAT}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroConsultaHistorico = {
            tipoTransaccion: this.props.filtro.tipoTransaccion,
            dniEmpleador: this.props.filtro.dniEmpleador,
            poliza: this.props.filtro.poliza,
            consecutivo: this.props.filtro.consecutivo,
            codigoSede: this.props.filtro.codigoSede,
            codigoCentroTrabajo: this.props.filtro.codigoCentroTrabajo,
            dniEmpleado: this.props.filtro.dniEmpleado,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderTexto = (props: any) => {
        return (
            <div style={{ marginTop: '10px' }}>
                <span>{props.value}</span>
            </div>
        );
    }

    renderDetalleJson = (props: any, stringJson: string) => {
        const subTitulo = `Consecutivo Respuesta: # ${props.original.consecutivo}`;
        return (
            <div style={{ marginTop: '5px' }}>
                <ModalDetalleJson
                    titulo={props.original.nombreServicio}
                    subTitulo={subTitulo}
                    stringJson={stringJson}
                />
            </div>
        );
    }
}

interface TablaRespuestasTSATProps {
    respuestasTSAT: Array<RespuestaTSAT>
    filtro: FiltroConsultaHistorico,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtro: FiltroConsultaHistorico) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_historico_rta/componentes/TablaRespuestasTSAT.tsx